import { NetworkTemplate, Response } from '@/types';
import gql from 'graphql-tag';
import { ApiService } from '@/services';

export class NetworkTemplateService extends ApiService {
  public async mutateNetworkTemplate(
    template: NetworkTemplate
  ): Promise<NetworkTemplate> {
    return template.id
      ? this.updateNetworkTemplate(template)
      : this.createNetworkTemplate(template);
  }

  public async updateNetworkTemplate(
    networkTemplate: NetworkTemplate
  ): Promise<NetworkTemplate> {
    const mutation = gql`
      mutation updateNetworkTemplate(
        $networkTemplate: AffiliateNetworkTemplateInput
      ) {
        updateNetworkTemplate(networkTemplate: $networkTemplate) {
          id
          template
          status
          affiliate_network {
            id
          }
        }
      }
    `;
    return this.mutate(
      { mutation, variables: { networkTemplate } },
      'updateNetworkTemplate'
    );
  }

  public async createNetworkTemplate(
    networkTemplate: NetworkTemplate
  ): Promise<NetworkTemplate> {
    const mutation = gql`
      mutation createNetworkTemplate(
        $networkTemplate: AffiliateNetworkTemplateInput
      ) {
        createNetworkTemplate(networkTemplate: $networkTemplate) {
          id
          template
          status
          affiliate_network {
            id
          }
        }
      }
    `;
    return this.mutate(
      { mutation, variables: { networkTemplate } },
      'createNetworkTemplate'
    );
  }

  public async deleteNetworkTemplate(id: number): Promise<Response> {
    const mutation = gql`
      mutation deleteNetworkTemplate($id: ID!) {
        deleteNetworkTemplate(id: $id) {
          id
          template
          status
        }
      }
    `;
    return await this.mutate(
      { mutation, variables: { id } },
      'deleteNetworkTemplate'
    );
  }
}

export const networkTemplateSvc: NetworkTemplateService = new NetworkTemplateService();
